"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UID = exports.UIDConfig = exports.UIDFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../validators");
exports.UIDFieldType = "UID";
exports.UIDConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    useAsTitle: t.boolean,
    placeholder: t.string,
}));
exports.UID = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.UIDFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.UIDConfig,
    }),
]));
